import { render } from "./ReplySearch.vue?vue&type=template&id=dbfcfe36&scoped=true"
import script from "./ReplySearch.vue?vue&type=script&lang=ts"
export * from "./ReplySearch.vue?vue&type=script&lang=ts"

import "./ReplySearch.vue?vue&type=style&index=0&id=dbfcfe36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbfcfe36"

export default script